// extracted by mini-css-extract-plugin
module.exports = {"switch":"dd31006766--switch--He7wp","indicator":"dd31006766--indicator--jttd7","label":"dd31006766--label--eS7WL"};